import React, { useState } from 'react';
import { Divider, InputNumber, Modal, Space, Spin, Typography, App, Input, Button } from 'antd';
import { CreditCardOutlined } from '@ant-design/icons';
import { _T } from '../../../../../base-react/src/Localization';
import { apis, models } from '@vote4dance/judging-sdk';
import dayjs from 'dayjs';
import { ButtonConfirm } from '../../../../../base-react/components/ButtonConfirm';
const { Text } = Typography;
const Api = apis.Api;
const CompetitionRegistrationSource = models.registration.CompetitionRegistrationSource;
export const PaymentInfo = ({ competitionId, paymentRef }) => {
    var _a, _b, _c, _d, _e, _f;
    const { notification, message } = App.useApp();
    const [open, setOpen] = useState(false);
    const [info, setInfo] = useState(null);
    const [loadingInfo, setLoadingInfo] = useState(false);
    const [refundAmount, setRefundAmount] = useState('');
    const [refundComment, setRefundComment] = useState('');
    const [loadingRefund, setLoadingRefund] = useState(false);
    const fetchInfo = async () => {
        var _a, _b, _c;
        setLoadingInfo(true);
        try {
            const res = await Api.call(`${CompetitionRegistrationSource(competitionId).url}`, 'payment-info', {
                payment_ref: paymentRef
            });
            setInfo(res);
            const base = Number((_b = (_a = res === null || res === void 0 ? void 0 : res.amount_received) !== null && _a !== void 0 ? _a : res === null || res === void 0 ? void 0 : res.amount) !== null && _b !== void 0 ? _b : 0) / 100;
            setRefundAmount(base.toFixed(2));
            setRefundComment('');
            setOpen(true);
        }
        catch (err) {
            notification.error({
                message: ((_c = err === null || err === void 0 ? void 0 : err.response) === null || _c === void 0 ? void 0 : _c.message) ? _T(err.response.message) : err.message
            });
        }
        finally {
            setLoadingInfo(false);
        }
    };
    const submitRefund = async () => {
        var _a;
        try {
            setLoadingRefund(true);
            await Api.call(`${CompetitionRegistrationSource(competitionId).url}`, 'payment-refund', {
                payment_ref: paymentRef,
                amount: Math.round(Number(refundAmount) * 100),
                description: refundComment
            });
            message.success(_T('common.apply.success', { name: _T('registration.payment').toLowerCase() }));
            setOpen(false);
        }
        catch (err) {
            notification.error({
                message: ((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.message) ? _T(err.response.message) : err.message
            });
        }
        finally {
            setLoadingRefund(false);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { icon: React.createElement(CreditCardOutlined, null), onClick: fetchInfo, loading: loadingInfo }, _T('registration.payment')),
        React.createElement(Modal, { title: _T('registration.payment'), open: open, onCancel: () => setOpen(false), footer: [
                React.createElement(Button, { key: "close", onClick: () => setOpen(false) }, _T('common.close'))
            ], width: 700 },
            !info && React.createElement(Spin, null),
            info && (React.createElement(Space, { orientation: "vertical", style: { width: '100%' } },
                React.createElement(Space, null,
                    React.createElement(Text, { strong: true }, "ID:"),
                    " ", info === null || info === void 0 ? void 0 :
                    info.id),
                React.createElement(Space, null,
                    React.createElement(Text, { strong: true }, "Status:"),
                    " ", info === null || info === void 0 ? void 0 :
                    info.status),
                React.createElement(Space, null,
                    React.createElement(Text, { strong: true }, "Amount:"),
                    " ",
                    (Number((info === null || info === void 0 ? void 0 : info.amount) || 0) / 100).toFixed(2),
                    " ", (_b = (_a = info === null || info === void 0 ? void 0 : info.currency) === null || _a === void 0 ? void 0 : _a.toUpperCase) === null || _b === void 0 ? void 0 :
                    _b.call(_a)),
                (info === null || info === void 0 ? void 0 : info.created) && (React.createElement(Space, null,
                    React.createElement(Text, { strong: true }, "Created:"),
                    " ",
                    dayjs.unix(Number(info.created)).format('LLL'))),
                (info === null || info === void 0 ? void 0 : info.customer) && (React.createElement(React.Fragment, null,
                    React.createElement(Divider, { size: 'small' }),
                    info.customer.name && React.createElement("div", null,
                        React.createElement(Text, { strong: true }, "Name:"),
                        " ",
                        info.customer.name),
                    info.customer.email && React.createElement("div", null,
                        React.createElement(Text, { strong: true }, "Email:"),
                        " ",
                        info.customer.email),
                    React.createElement("div", null,
                        React.createElement(Text, { strong: true }, "Country:"),
                        " ",
                        info.customer.country))),
                React.createElement(Divider, { size: 'small' }),
                React.createElement(Space, { orientation: "vertical", style: { width: '100%' } },
                    React.createElement(Text, { strong: true }, _T('registration.refund')),
                    info && (React.createElement(Text, { type: "secondary" },
                        React.createElement(Space, null,
                            _T('common.max'),
                            ((Number((_d = (_c = info === null || info === void 0 ? void 0 : info.amount_received) !== null && _c !== void 0 ? _c : info === null || info === void 0 ? void 0 : info.amount) !== null && _d !== void 0 ? _d : 0) / 100).toFixed(2) + ' ' + (((_f = (_e = info === null || info === void 0 ? void 0 : info.currency) === null || _e === void 0 ? void 0 : _e.toUpperCase) === null || _f === void 0 ? void 0 : _f.call(_e)) || ''))))),
                    info && (() => {
                        var _a, _b;
                        const max = Number((_b = (_a = info === null || info === void 0 ? void 0 : info.amount_received) !== null && _a !== void 0 ? _a : info === null || info === void 0 ? void 0 : info.amount) !== null && _b !== void 0 ? _b : 0) / 100;
                        return (React.createElement(InputNumber, { min: "0", max: max.toFixed(1), step: 0.01, stringMode: true, value: refundAmount, onChange: (v) => setRefundAmount(v ? String(v) : ''), style: { width: '100%' } }));
                    })(),
                    React.createElement(Input.TextArea, { rows: 3, placeholder: _T('common.description'), value: refundComment, onChange: e => setRefundComment(e.target.value) }),
                    React.createElement(ButtonConfirm, { onConfirm: async (done) => {
                            await submitRefund();
                            done();
                        }, description: _T('registration.refund'), buttonProps: {
                            type: 'dashed',
                            danger: true,
                            loading: loadingRefund,
                            label: _T('registration.refund')
                        } })))))));
};
